export function secondsToFrames(seconds: number, fps: number): number {
  return Math.round(seconds * fps)
}

export function framesToSeconds(frames: number, fps: number): number {
  return frames / fps
}

export function rangeToFrames(startSeconds: number, endSeconds: number, fps: number): {
  startFrame: number
  endFrame: number
  durationFrames: number
} {
  const startFrame = secondsToFrames(startSeconds, fps)
  const endFrame = secondsToFrames(endSeconds, fps)
  return {
    startFrame,
    endFrame,
    durationFrames: Math.max(1, endFrame - startFrame),
  }
}
